<template>
  <CustomTableCanDropDrag
    :draggable="!isChecklistStatusDone"
    :columns="columnsTableFields"
    :data="dataTable"
    :is-loading="isLoading || isReordering"
    :id-item-expland="idItemExpland"
    :question-before-sort="true"
    header-wrapper-class="!tw-bg-[#FCFCFD]"
    :is-action-table="true"
    :is-recommend="true"
    @update-selected-rows="updateSelectedRows($event)"
    @click-sort-column="handleClickSortColumn"
    @added="addData"
    @moved="reorderList"
    @updated-data="updateData"
    @add-all-selected="addAllSelected"
    @clicked-row="onClickOpenRow"
  >
    <template #cell(title)="data">
      <div class="tw-flex tw-gap-[17px] tw-items-center">
        <StartIcon v-if="data?.item?.checklistGroupIsQuickWin" />
        <div class="tw-flex tw-items-center tw-mt-[2px]">
          <span class="title" data-cy="actions-table-title">
            {{ data?.item?.title }}
            <span class="score-title"
              >({{ data?.item?.checklistGroupItemCount }})</span
            >
          </span>
          <div
            v-if="data.item?.checklistGroupId === idItemReordering"
            class="tw-h-[35px] tw-w-[35px]"
          >
            <!-- eslint-disable vue/no-unused-refs -->
            <LottieAnimation
              ref="anim"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
          </div>
        </div>
      </div>
    </template>
    <template #cell(status)="data">
      <div class="absolute_cell tw-flex tw-items-center">
        <div
          class="tw-flex tw-justify-center tw-items-center tw-flex-1 tw-h-full"
          @click="(e) => onClickOpenRow(data.item, columnsTableFields[0], e)"
        >
          <AssessmentChecklistStatusTag
            v-if="data.item.checklistGroupCompletionPcnt !== null"
            :checklist-status="
              data.item.checklistGroupCompletionPcnt === 1
                ? getComponentUiText(
                    'app-component-assessments-checklists-assessment-details-card-status-3',
                  )
                : data.item.checklistGroupCompletionPcnt > 0 &&
                    data.item.checklistGroupCompletionPcnt < 1
                  ? getComponentUiText(
                      'app-component-assessments-checklists-assessment-details-card-status-1',
                    )
                  : getComponentUiText(
                      'app-component-assessments-checklists-assessment-details-card-status-2',
                    )
            "
            :checklist-status-id="
              data.item.checklistGroupCompletionPcnt === 1
                ? CHECKLISTSTATUS.DONE
                : data.item.checklistGroupCompletionPcnt > 0 &&
                    data.item.checklistGroupCompletionPcnt < 1
                  ? CHECKLISTSTATUS.INPROG
                  : CHECKLISTSTATUS.NEW
            "
            :class-name="'!tw-py-0'"
            :is-loading="false"
          />
        </div>
        <div class="tw-w-2 tw-h-full tw-cursor-default"></div>
      </div>
    </template>
    <template #cell(completionDate)="data">
      <div class="absolute_cell tw-flex tw-items-center">
        <div
          class="tw-cursor-pointer tw-h-full tw-items-center tw-flex-1 tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%] tw-font-[Poppins] tw-flex tw-justify-center"
          @click="() => handleClickCompletionDate(data.item.id)"
        >
          <div
            v-if="data.item.completionDate"
            class="tw-px-[5px] tw-w-fit tw-py-[3px] tw-h-[20px] tw-bg-[#E4F1FF] tw-rounded-[4px]"
          >
            {{ convertUTCTimeToLocalTime(data.item.completionDate) }}
          </div>
          <div v-else>
            {{
              getComponentUiText(
                "app-recommend-action-table-title-button-add-date-1",
              )
            }}
          </div>
        </div>
        <div class="tw-w-2 tw-h-full" />
        <div
          class="tw-w-[40px] tw-h-full tw-cursor-pointer"
          @click="(e) => onClickOpenRow(data.item, columnsTableFields[0], e)"
        />
      </div>
    </template>
    <template #cell(scoreIncreaseTotal)="data">
      <!-- <div class="tw-flex tw-justify-center"> -->
      <ScoreIncrease
        :first-score="data.item.scoreIncreaseFirstCount"
        :total-score="data.item.scoreIncreaseTotal"
      />
      <!-- </div> -->
    </template>
    <template #cell(relativeRiskValue)="data">
      <div class="absolute_cell tw-flex tw-items-center">
        <div class="tw-w-2 tw-h-full tw-cursor-default" />
        <div
          class="tw-cursor-pointer tw-flex tw-justify-center tw-w-full tw-h-full"
        >
          <StatusBadge
            v-if="getTagRelativeRisk(data.value, dataPercentile)"
            :value="getTagRelativeRisk(data.value, dataPercentile) ?? ''"
            class="tw-w-fit"
          />
        </div>
        <div class="tw-w-2 tw-h-full" />
        <div
          class="tw-w-[25px] tw-h-full tw-cursor-pointer"
          @click="(e) => onClickOpenRow(data.item, columnsTableFields[0], e)"
        />
      </div>
    </template>
    <template #cell(action)="data">
      <div
        class="tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-left-0 tw-flex tw-flex-row tw-items-center"
      >
        <div class="tw-w-2 tw-h-full" />
        <div
          class="tw-relative tw-flex-1 tw-h-full tw-w-[45px] tw-flex tw-items-center"
        >
          <CellTableAction
            :id="
              'recom-action-table-' +
              (data.tablePrefix || '') +
              data.item.checklistGroupId
            "
            data-cy-id="recom-action-table"
            :disabled="isChecklistStatusDone"
            class="tw-overflow-hidden tw-h-full"
            :value="data"
            :is-internal="false"
            :actions="tableFileActions"
            :class-button="'tw-w-[45px]'"
            @manage-user="handleActionClick"
          />
        </div>
        <div class="tw-w-2 tw-h-full" />
      </div>
    </template>

    <template #cell(expland)="data">
      <div class="">
        <ArrowDownTableIcon
          :class="[
            data.item.id === idItemExpland ? 'show' : '',
            'tw-cursor-pointer',
          ]"
        />
      </div>
    </template>
    <template #detail="data">
      <DetailRowActionTable
        :id-item-expand="idItemExpland"
        :detail-data="data"
        :is-action-table="true"
      />
    </template>
  </CustomTableCanDropDrag>
</template>

<script lang="ts" setup>
import { Ref, ref, watch } from "vue";
import { CustomTableColumn } from "../common/customTable.vue";
import { getComponentUiText, getTagRelativeRisk } from "@/utils/utilities";
import CustomTableCanDropDrag from "@/components/common/customTableCanDropDrag.vue";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";

import CellTableAction from "@/components/common/setting/cellTableAction.vue";
import ScoreIncrease from "@/components/assessments/scoreIncreaseElement.vue";
import StatusBadge from "@/components/common/setting/statusBadge.vue";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import DetailRowActionTable from "../recommend/detailRowActionTable.vue";
import StartIcon from "@/components/svgs/startIcon.vue";
import {
  actionClickType,
  RECOMMENDATION_ACTION_PcnT,
  RECOMMENDATION_FORCE_RESORT,
  successStatusCodes,
} from "@/utils/constants";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  MODAL_NAME,
  VALUE_SORT_COLUMN_ACTION_MODAL,
  indexColumnActionTable,
  localStorageKey,
} from "@/utils/constants";
import cloneDeep from "lodash/cloneDeep";
import store from "@/store";
import { computed } from "vue";
import { ToastVariant } from "@/interfaces/common/IToastMessage";
import {
  removeActionTable,
  putChecklistGroup,
  getChecklistGroups,
} from "@/services/recommend";
import { showErrorAPI, showToastMessage } from "@/services/apiRoutes";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import { CHECKLISTSTATUS } from "@/utils/constants";
import { Checklist } from "@/services/apiRoutes/routes";
export type dataActionTableColumn = {
  id: any;
  title: string;
  scoreIncreaseTotal: number;
  scoreIncreaseFirstCount: number;
  riskReduction: "High" | "Significant";
};

const props = defineProps({
  dataRow: {
    type: Array as () => dataActionTableColumn[],
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  isChecklistStatusDone: {
    type: Boolean,
    required: false,
  },
  suggestedSelectedRows: {
    type: Array as () => any[],
    required: false,
    default: () => [],
  },
  assessmentSelectedRows: {
    type: Array as () => any[],
    required: false,
    default: () => [],
  },
});
const currentActionTable: Ref<any> = ref({});
const dataTable = ref(props.dataRow);
const currentSeletedRow: any = ref([]);
const isReordering: any = ref(false);
const idItemReordering: Ref<any> = ref(null);
const dataPercentile: Ref<any> = computed(() => {
  return store.state.Recommend.recommendPercentileChecklistGroupMetrics;
});
const idItemExpland = ref(null);
let currentSuggestedSelectedRows: any[] = props.suggestedSelectedRows;
let currentAssessmentSelectedRows: any[] = props.suggestedSelectedRows;

const tableFileActions = [
  actionClickType.actionEditActionRecomendation,
  actionClickType.actionDeleteActionRecomendation,
  actionClickType.actionMarkAsComplete,
  actionClickType.actionMarkAsInProgress,
  actionClickType.actionMarkAsNotStarted,
  actionClickType.actionMarkAsQuickWinRecomendation,
  actionClickType.actionClearStatus,
];

const emit = defineEmits([
  "update-selected-rows",
  "update-is-sort-by-risk",
  "update-add-action",
]);

watch(currentSeletedRow, (value) => {
  store.commit("Recommend/SET_SELECTED_ACTIONS_ROW", value);
});

const onClickOpenRow = (item, col, e) => {
  if (!col.isActiveClick) return;
  if (item.id === idItemExpland.value) {
    idItemExpland.value = null;
  } else {
    idItemExpland.value = item.id;
  }
};
const addData = (data) => {
  if (data.isSuggestionsAction) {
    if (
      currentSuggestedSelectedRows.findIndex(
        (item) => item.id === data.element.id,
      ) !== -1
    ) {
      // multi
      emit("update-add-action", {
        addedActions: currentSuggestedSelectedRows,
        isSuggestionsAction: true,
      });
    } else
      emit("update-add-action", {
        addedActions: [data.element],
        isSuggestionsAction: true,
      }); // single
  }
};

const addAllSelected = () => {
  emit("update-add-action", {
    isAddAll: true,
  });
};

const reorderList = async (data) => {
  let res;
  let currentList = cloneDeep(dataTable.value);
  idItemReordering.value = data.element.checklistGroupId;
  if (data.newIndex === 0) {
    res = await store.dispatch("Recommend/reorderAction", {
      checklistId: store.getters["Recommend/getChecklistReportId"],
      checklistGroupId: currentList[data.oldIndex]["checklistGroupId"],
      order: 1,
    });
  } else if (data.newIndex === currentList.length - 1) {
    const maxOrder = currentList.reduce(
      (max, obj) =>
        obj["checklistGroupOrder"] > max ? obj["checklistGroupOrder"] : max,
      0,
    );
    res = await store.dispatch("Recommend/reorderAction", {
      checklistId: store.getters["Recommend/getChecklistReportId"],
      checklistGroupId: currentList[data.oldIndex]["checklistGroupId"],
      order: maxOrder + 1,
    });
  } else if (data.oldIndex > data.newIndex) {
    res = await store.dispatch("Recommend/reorderAction", {
      checklistId: store.getters["Recommend/getChecklistReportId"],
      checklistGroupId: currentList[data.oldIndex]["checklistGroupId"],
      order: +currentList[data.newIndex - 1]["checklistGroupOrder"] + 1,
    });
  } else if (data.oldIndex < data.newIndex) {
    res = await store.dispatch("Recommend/reorderAction", {
      checklistId: store.getters["Recommend/getChecklistReportId"],
      checklistGroupId: currentList[data.oldIndex]["checklistGroupId"],
      order: +currentList[data.newIndex + 1]["checklistGroupOrder"] - 1,
    });
  }
  if (res.status !== successStatusCodes.OK) {
    dataTable.value = currentList;
  } else {
    const itemUpdated = res.data.data;
    const checklistGroups = await getChecklistGroups(itemUpdated.checklistId);
    const updatedList = checklistGroups.data.data.checklistGroups.map(
      (group) => {
        const item = currentList.find(
          (item) => item.checklistGroupId === group.checklistGroupId,
        );
        return {
          ...item,
          checklistGroupOrder: group.checklistGroupOrder,
        };
      },
    );
    dataTable.value = updatedList;
  }
  setTimeout(() => {
    idItemReordering.value = null;
  }, 50);
};

const updateSelectedRows = (seletedRow) => {
  currentSeletedRow.value = dataTable.value.filter((item) =>
    seletedRow.includes(item.id),
  );
  emit("update-selected-rows", seletedRow);
};

const handleClickSortColumn = (column, index) => {
  if (
    localStorage.getItem(localStorageKey.isDontShowModalReOrderAction) !==
      "true" &&
    column.value !== VALUE_SORT_COLUMN_ACTION_MODAL.completionDate
  ) {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_REORDER_ACTION_MODAL,
      properties: {
        title: getComponentUiText(
          "app-assess-recommendations-modal-reorder-title-1",
        ),
        description:
          column.value === VALUE_SORT_COLUMN_ACTION_MODAL.riskReduction
            ? getComponentUiText(
                "app-assess-recommendations-modal-reorder-description-a-1",
              )
            : getComponentUiText(
                "app-assess-recommendations-modal-reorder-description-b-1",
              ),
        buttonText: getComponentUiText(
          "app-assess-recommendations-modal-reorder-button-title-reorder-1",
        ),
      },
      events: { "update:data": () => updateSortColumn(column, index) },
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  } else {
    updateSortColumn(column, index);
  }
};

const updateSortColumn = (column, index) => {
  emit("update-is-sort-by-risk", index === indexColumnActionTable.risk);
  EventEmitter.emit(EmitterEvents.CLICK_SORT_COLUMN_ACTION_TABLE, {
    index: index,
    column: column,
  });
};

const columnsTableFields = computed<CustomTableColumn[]>(() => [
  {
    text: getComponentUiText("app-user-profile-form-label-title-1"),
    value: "title",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
    valueClass: "!tw-relative tw-min-h-[60px] tw-cursor-pointer",
    sortable: false,
    headerWrapperId: "",
    isActiveClick: true,
  },
  {
    text: getComponentUiText("app-recommend-action-table-status-title-1"),
    value: "status",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-pr-[40px] tw-table tw-mx-auto",
    valueClass: "!tw-w-[120px] !tw-pr-[10px] !tw-relative tw-cursor-pointer",
    headerWrapperId: "",
    sortable: false,
  },
  {
    text: getComponentUiText(
      "app-recommend-action-table-completion-date-title-1",
    ),
    value: "completionDate",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-pr-[40px]",
    valueClass: "!tw-w-[130px] !tw-relative !tw-p-0",
    headerWrapperId: "recom-action-table-completion-date",
    sortable: false,
  },
  {
    text: getComponentUiText(
      "app-assess-recommendations-action-table-header-score-increase-1",
    ),
    value: "scoreIncreaseTotal",
    // style center tw-w-[260px] tw-flex tw-justify-center
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-pr-[40px]",
    valueClass: "!tw-w-[280px] !tw-relative tw-cursor-pointer",
    sortable: !props.isChecklistStatusDone,
    headerWrapperId: "recom-action-table-score-increase",
    sortDefault: true,
    isActiveClick: true,
  },
  {
    text: getComponentUiText(
      "app-assess-recommendations-action-table-header-relative-risk-1",
    ),
    value: "relativeRiskValue",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase !tw-pr-0",
    valueClass: "!tw-w-[111px] !tw-relative",
    headerWrapperId: "recom-action-table-relative-risk",
    sortable: !props.isChecklistStatusDone,
    sortDefault: false,
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "!tw-w-[61px] !tw-px-0 !tw-py-0 !tw-relative",
  },
  {
    text: "",
    value: "expland",
    headerClass: "",
    valueClass: "!tw-w-[12px] tw-cursor-pointer",
    isActiveClick: true,
  },
]);

const handleClickCompletionDate = (id: number) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_SECURITY_AND_STABILITY_SCORE,
    properties: {
      data: dataTable.value,
      idSelected: id,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleActionClick = (value: any, action: string, id: any) => {
  switch (action) {
    case actionClickType.actionEditActionRecomendation:
      onShowEditActionModal(value);
      // addAction(id);
      break;
    case actionClickType.actionDeleteActionRecomendation:
      handleRemoveAction(value);
      break;
    case actionClickType.actionMarkAsComplete:
      markActionStatus(value, actionClickType.actionMarkAsComplete);
      break;
    case actionClickType.actionMarkAsInProgress:
      markActionStatus(value, actionClickType.actionMarkAsInProgress);
      break;
    case actionClickType.actionMarkAsNotStarted:
      markActionStatus(value, actionClickType.actionMarkAsNotStarted);
      break;
    case actionClickType.actionClearStatus:
      markActionStatus(value, actionClickType.actionClearStatus);
      break;
    case actionClickType.actionMarkAsQuickWinRecomendation:
      markAsQuickWin(value);
      break;
    default:
      break;
  }
};
const showModalRemoveAction = (data: {
  title: string;
  description: string;
  buttonRed: boolean;
  questionContain: string;
  additionalNote: string;
  onUpdate: (payload: any) => void;
}) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: data.title ? getComponentUiText(data.title) : "",
      description: data.description ? getComponentUiText(data.description) : "",
      questionContain: data.questionContain,
      additionalNote: data.additionalNote,
      updateDataFunction: data.onUpdate,
    },
    events: {
      "update:data": () => data.onUpdate({}),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
const handleRemoveAction = (value: any) => {
  currentActionTable.value = value;
  showModalRemoveAction({
    title: "app-assess-recommend-action-delete-action-title-1",
    description: "app-assess-recommend-are-you-sure-content-delete-1",
    questionContain: getComponentUiText(
      "app-assess-recommend-action-delete-action-button-1",
    ),
    additionalNote: getComponentUiText(
      "app-assess-recommend-are-you-sure-content-delete-2",
    ),
    buttonRed: true,
    onUpdate: removeAction,
  });
};
const removeAction = async () => {
  try {
    const payload = {
      checklistGroupIds: [currentActionTable.value.checklistGroupId],
      checklistId: store.getters["Recommend/getChecklistReportId"],
    };
    const res = await removeActionTable(payload);
    if (!(res.status === successStatusCodes.OK)) {
      showToastMessage(
        res?.data?.error?.message ||
          getComponentUiText("app-exception-handler-error-unknown-error"),
        ToastVariant.ERROR,
      );
    } else {
      EventEmitter.emit(EmitterEvents.RELOAD_RECOMMENDATION_ACTIONS);
      showToastMessage(res?.data?.message, ToastVariant.SUCCESS);
    }
  } catch (error: any) {
    showErrorAPI(error, Checklist.removeActionTable);
  }
};
const markActionStatus = async (value: any, action: string) => {
  try {
    let completionPcnt;
    if (action === actionClickType.actionMarkAsComplete) {
      completionPcnt = RECOMMENDATION_ACTION_PcnT.completion;
    } else if (action === actionClickType.actionMarkAsInProgress) {
      completionPcnt = RECOMMENDATION_ACTION_PcnT.inProgress;
    } else if (action === actionClickType.actionMarkAsNotStarted) {
      completionPcnt = RECOMMENDATION_ACTION_PcnT.notStarted;
    } else {
      completionPcnt = RECOMMENDATION_ACTION_PcnT.reset;
    }
    const payload = {
      checklistGroupId: value.checklistGroupId,
      checklistId: store.getters["Recommend/getChecklistReportId"],
      completionPcnt,
    };
    const res = await putChecklistGroup(payload);
    if (!(res.status === successStatusCodes.OK)) {
      showToastMessage(
        res?.data?.error?.message ||
          getComponentUiText("app-exception-handler-error-unknown-error"),
        ToastVariant.ERROR,
      );
    } else {
      const currentList = cloneDeep(dataTable.value);
      const index = currentList.findIndex(
        (item) => item["checklistGroupId"] === value.checklistGroupId,
      );
      currentList[index]["checklistGroupCompletionPcnt"] = completionPcnt;
      await store.commit(
        "Recommend/SET_RECOM_CHECKLIST_GROUP_METRICS",
        currentList,
      );
      showToastMessage(res?.data?.message, ToastVariant.SUCCESS);
    }
  } catch (error: any) {
    showErrorAPI(error, Checklist.updateChecklistItemGroup);
  }
};
const onShowEditActionModal = (action: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMENDATION_EDIT_ACTIONS,
    properties: {
      action,
      isEditActionTable: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
const updateData = async (data) => {
  isReordering.value = true;
  await store.dispatch("Recommend/bulkReorderAction", {
    checklistId: store.getters["Recommend/getChecklistReportId"],
    data,
  });
  setTimeout(async () => {
    await store.dispatch("Recommend/fetchRecomChecklistGroupMetrics");
    isReordering.value = false;
  }, 500);
};

const markAsQuickWin = async (value: any) => {
  try {
    const payload = {
      checklistGroupId: value.checklistGroupId,
      checklistId: store.getters["Recommend/getChecklistReportId"],
      isQuickWin: !value.checklistGroupIsQuickWin,
    };
    const res = await putChecklistGroup(payload);
    if (!(res.status === successStatusCodes.OK)) {
      showToastMessage(
        res?.data?.error?.message ||
          getComponentUiText("app-exception-handler-error-unknown-error"),
        ToastVariant.ERROR,
      );
    } else {
      const currentList = cloneDeep(dataTable.value);
      const index = currentList.findIndex(
        (item) => item["checklistGroupId"] === value.checklistGroupId,
      );
      currentList[index]["checklistGroupIsQuickWin"] =
        !currentList[index]["checklistGroupIsQuickWin"];
      dataTable.value = currentList;
      await store.commit(
        "Recommend/SET_RECOM_CHECKLIST_GROUP_METRICS",
        currentList,
      );
      showToastMessage(res?.data?.message, ToastVariant.SUCCESS);
    }
  } catch (error: any) {
    showErrorAPI(error, Checklist.updateChecklistItemGroup);
  }
};

watch(
  () => props.dataRow,
  () => {
    dataTable.value = props.dataRow;
  },
);

watch(
  () => props.isLoading,
  () => {
    if (!props.isLoading) {
      setTimeout(() => {
        if (props.dataRow.length === 0) {
          EventEmitter.emit(EmitterEvents.RESET_SORT_TABLE);
        } else {
          EventEmitter.emit(EmitterEvents.RESET_SORT_TABLE, {
            key: RECOMMENDATION_FORCE_RESORT.isInit,
          });
        }
      }, 200);
    }
  },
);

watch(
  () => props.suggestedSelectedRows,
  () => {
    currentSuggestedSelectedRows = props.suggestedSelectedRows;
  },
);

watch(
  () => props.assessmentSelectedRows,
  () => {
    currentAssessmentSelectedRows = props.assessmentSelectedRows;
  },
);
</script>

<style lang="scss" scoped>
.absolute_cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.show {
  transform: rotate(180deg);
}
.title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 16.9px */
  margin-right: 4px;
}
.score-title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
</style>
